import React from 'react';
import Check from '../../../../atoms/SvgIcon/Icons/Check';
import Cross from '../../../../atoms/SvgIcon/Icons/Cross';
import InfoCircle from '../../../../atoms/SvgIcon/Icons/InfoCircle';
import Warning from '../../../../atoms/SvgIcon/Icons/Warning';
import toastTypes from '../toastTypes';
const defaultIconMapping = (type)=>{
    switch(type){
        case toastTypes.INFO:
            return /*#__PURE__*/ React.createElement(InfoCircle, null);
        case toastTypes.SUCCESS:
            return /*#__PURE__*/ React.createElement(Check, null);
        case toastTypes.WARNING:
            return /*#__PURE__*/ React.createElement(Warning, null);
        case toastTypes.ERROR:
            return /*#__PURE__*/ React.createElement(Cross, null);
        default:
            return null;
    }
};
export const resolveIcon = (renderIcon, iconMapping, type)=>{
    if (renderIcon) {
        if (iconMapping) {
            return iconMapping(type) || defaultIconMapping(type);
        } else {
            return defaultIconMapping(type);
        }
    } else {
        return null;
    }
};
